export default {
    rating: {
        please_rate: 'Пожалуйста, оцените услугу (от 1 до 5)',
        google_rate: 'Хотели бы вы также поделиться своим опытом на нашем профиле Google Бизнес?',
        comment: {
            label: 'Комментарий',
            placeholder: 'Введите комментарий',
        },
    },
}
